import api from "../axiosConfig";
import { useQuery } from "react-query";
export default function useGetSavedAdviceGuides() {
  const fetchSavedAdviceGuides = async () => {
    return await api.get("saved/advice-guides").then((res) => res);
  };

  return useQuery("saved-advice-guides", fetchSavedAdviceGuides);
}
